import { gql } from '@apollo/client';

export const GET_MY_FIELD_SESSIONS_QUERY = gql`
  query GetMyFieldSessionsQuery($limit: Int!) {
    getMyFieldSessions(pagination: { limit: $limit }) {
      id
      clientId
      createdAt
      updatedAt
      startedAt
      endedAt
      siteId
      siteName
      name
      note
      activeDurationSeconds
      distanceMeters
      findCount
      track
    }
  }
`;
